import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  ocrData: {},
  UID: null,
  loading: false,
  error: null,
};

export const ocrSlice = createSlice({
  name: 'ocr',
  initialState,
  reducers: {
    getOcrDataSuccess: (state, action) => {
      state.ocrData = action.payload;
      state.loading = false;
    },
    setUID: (state, action) => {
      state.UID = action.payload;
    },
    resetUID: (state) => {
      state.UID = null;
    },
    resetOcrState: (state) => {
      state.ocrData = {};
      state.loading = false;
      state.error = null;
    },
  },
});

export const { getOcrDataSuccess, resetOcrState, setUID, resetUID } = ocrSlice.actions;

export default ocrSlice.reducer;
